module.exports = __webpack_public_path__ + "img/icon_menu_up.4000c729.svg";